// API Status Code
export const successStatusCode = 200;
export const reportWidgetName = [
  "registered_user",
  "registered_company",
  "registered_kits",
  "safety_kit_installed",
];

export const distributorRoles = [
  "distributor_superadmin",
  "distributor_user",
  "distributor_salesrepresentative",
];

export const adminRoles = [
  "rm_superadmin",
  "rm_admin",
  "admin",
  "approver",
  "user",
  "salesrepresentative",
];
